import { queryOptions } from '@tanstack/react-query';
import { maxRolesQueryOptions } from '#api/roles.queries.ts';

export const ALL_ROLES_FLAG = 'all';

const ALL_HOSTS_OPTION: { value: string; label: string } = { value: ALL_ROLES_FLAG, label: 'All hosts' };

export const rolesForSelectionQueryOptions = queryOptions({
  ...maxRolesQueryOptions,
  select: ({ data }) => ({
    items: [ALL_HOSTS_OPTION].concat(data.map((role) => ({ value: role.id, label: role.name }))),
  }),
});
